import { DoDB } from './ddb';
import { versionSort } from './manualUtils';

// Query published apps that have at least one manual revision and are flagged
// for the homepage or eIFU. Shared by the public portal and the admin console
// so both read the exact same source set.
export const getPublishedApps = async () => {
  const params = {
    TableName: 'rayrnd-applications',
    IndexName: 'type-name-index',
    KeyConditionExpression: '#type = :type',
    FilterExpression:
      '#is_active=:t and #isdev=:n and (#showHome=:t or #show_eifu=:t) and attribute_exists(#manualRevisions[0])',
    ExpressionAttributeNames: {
      '#type': 'type',
      '#is_active': 'is_active',
      '#isdev': 'isdev',
      '#showHome': 'showHome',
      '#show_eifu': 'show_eifu',
      '#manualRevisions': 'manualRevisions',
    },
    ExpressionAttributeValues: { ':type': 'app', ':t': true, ':n': 'N' },
  };
  const list = await DoDB('query', params);
  return list;
};

// Flatten every app's manualRevisions into a single list, each item carrying its
// owning app via `_app_info` (same shape the portal builds internally).
export const flattenManuals = (apps) => {
  let docs = [];
  for (const _app of apps || []) {
    let manualRevisions = _app.manualRevisions || [];
    if (manualRevisions.length === 0) {
      continue;
    }
    manualRevisions = versionSort(manualRevisions, 'revision');
    manualRevisions = manualRevisions.map((x) => ({ ...x, _app_info: _app }));
    docs = [...docs, ...manualRevisions];
  }
  return docs;
};
